/** @flow */
import { darkBlack, fullBlack, grey300, white } from 'material-ui/styles/colors';
import * as ColorManipulator from 'material-ui/utils/colorManipulator';
import Spacing from 'material-ui/styles/spacing';
import zIndex from 'material-ui/styles/zIndex';
import { Colors, Fonts } from './index';

export const MUITheme = {
  palette: {
    primary: {
      main: Colors.primary,
      dark: Colors.primary,
      contrastText: Colors.tertiaryText,
    },
    secondary: {
      main: Colors.primaryBackground,
      dark: Colors.primaryBackground,
      contrastText: Colors.secondaryText,
    },
    text: {
      main: Colors.secondaryText,
    },
  },
  overrides: {
    MuiInput: {
      underline: { // override bottom border for all input to be the primary color
        '&:hover:not($disabled):before': {
          borderColor: Colors.primary,
          height: 1,
        },
      },
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: Fonts.type.base,
  },
  zIndex,
};

export const MUI0Theme = {
  spacing: Spacing,
  zIndex: zIndex,
  fontFamily: MUITheme.typography.fontFamily,
  palette: {
    primary1Color: MUITheme.palette.primary.main,
    primary2Color: MUITheme.palette.primary.main,
    accent1Color: '#B6B6B4',
    textColor: MUITheme.palette.text.main,
    borderColor: '#B6B6B4',
    disabledColor: ColorManipulator.fade(darkBlack, 0.3),
    clockCircleColor: ColorManipulator.fade(darkBlack, 0.07),
    shadowColor: fullBlack,
  },
  avatar: {
    borderColor: grey300,
  },
  floatingActionButton: {
    disabledColor: Colors.primary,
    disabledTextColor: white,
  },
  raisedButton: {},
  timePicker: {
    headerColor: Colors.primary,
    clockColor: Colors.primary,
    color: Colors.primaryText,
  },
  toolbar: {
    backgroundColor: Colors.primary,
  },
};



// WEBPACK FOOTER //
// ./src/statsradio/themes/MuiTheme.js